exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-button[data-v-1371031d] {\n  margin: 0 auto;\n}\n@media only screen and (max-width: 600px) {\n.modal-header span[data-v-1371031d] {\n    margin-top: 20px;\n}\n}\n.verify-phone-number[data-v-1371031d] {\n  padding: 25px;\n  padding-bottom: 5px;\n}\n.send-sms[data-v-1371031d] {\n  text-decoration: underline;\n  text-align: center;\n  margin-bottom: 30px;\n  color: #11bb2e;\n  cursor: pointer;\n}\n.disabled[data-v-1371031d] {\n  color: gray;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n", ""]);

// exports
